module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edi-register"
  }, [_c('navbar', {
    attrs: {
      "title": "用户注册"
    }
  }), _vm._v(" "), _c('form', {
    staticClass: "ui-content",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register.apply(null, arguments)
      }
    }
  }, [_c('ul', {
    staticClass: "ui-listview ui-listview-inset"
  }, [_c('li', {
    staticClass: "ui-listview-first-item"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.company),
      expression: "company"
    }],
    attrs: {
      "type": "text",
      "name": "company",
      "placeholder": "企业名称"
    },
    domProps: {
      "value": (_vm.company)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.company = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telephone),
      expression: "telephone"
    }],
    attrs: {
      "type": "text",
      "name": "telephone",
      "placeholder": "手机号"
    },
    domProps: {
      "value": (_vm.telephone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telephone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    attrs: {
      "type": "text",
      "name": "verifyCode",
      "placeholder": "图形验证码"
    },
    domProps: {
      "value": (_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "src": _vm.verifyCodeImg
    },
    on: {
      "click": _vm.refreshVerifyCodeClick
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "ui-listview-last-item"
  }, [_c('div', {
    staticClass: "ui-col-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.code),
      expression: "code"
    }],
    attrs: {
      "type": "text",
      "name": "code",
      "placeholder": "验证码"
    },
    domProps: {
      "value": (_vm.code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.code = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "ui-col-4 ui-align-right"
  }, [_c('mobile-code', {
    attrs: {
      "type": 1,
      "mobile": _vm.telephone,
      "verifyCode": _vm.verifyCode,
      "uuid": _vm.verifyUUID
    },
    on: {
      "on-refresh": _vm.refreshVerifyCodeClick
    }
  })], 1)])]), _vm._v(" "), _c('fieldset', {
    staticClass: "ui-controlgroup"
  }, [(_vm.disabled) ? _c('input', {
    staticClass: "ui-btn-disable",
    attrs: {
      "type": "submit",
      "value": "注册",
      "disabled": "true"
    }
  }) : _c('input', {
    staticClass: "submit",
    attrs: {
      "type": "submit",
      "value": "注册"
    }
  })])]), _vm._v(" "), _c('tips', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tips),
      expression: "tips"
    }],
    attrs: {
      "btnNum": _vm.btnNum,
      "tipsFont": _vm.tipsFont
    },
    on: {
      "tipStatus": _vm.tipStatus
    }
  }), _vm._v(" "), _c('tips-auto', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipsauto),
      expression: "tipsauto"
    }],
    attrs: {
      "tipsFont": _vm.tipsFont
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c351838!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Register.vue
// module id = 595
// module chunks = 1